var domSafe = function domSafe() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

var sendTracking = function sendTracking(values) {
  // For pushing data directly to the dataLayer
  if (domSafe()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(values);
  }
};

var clearEcommerceObject = function clearEcommerceObject() {
  if (domSafe()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ecommerce: null
    });
  }
};

var viewItemList = function viewItemList(_a) {
  var items = _a.items,
      item_list_id = _a.item_list_id,
      item_list_name = _a.item_list_name;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.view_item_list',
    ecommerce: {
      item_list_id: item_list_id,
      item_list_name: item_list_name,
      items: items
    }
  });
};

var selectItem = function selectItem(_a) {
  var items = _a.items,
      item_list_id = _a.item_list_id,
      item_list_name = _a.item_list_name;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.select_item',
    ecommerce: {
      item_list_id: item_list_id,
      item_list_name: item_list_name,
      items: items
    }
  });
};

var viewItemDetails = function viewItemDetails(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.view_item',
    ecommerce: {
      currency: currency,
      value: value,
      items: items
    }
  });
};

var addToWishlist = function addToWishlist(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.add_to_wishlist',
    ecommerce: {
      currency: currency,
      value: value,
      items: items
    }
  });
};

var addToCart = function addToCart(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.add_to_cart',
    ecommerce: {
      currency: currency,
      value: value,
      items: items
    }
  });
};

var removeFromCart = function removeFromCart(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.remove_from_cart',
    ecommerce: {
      currency: currency,
      value: value,
      items: items
    }
  });
};

var viewCart = function viewCart(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.view_cart',
    ecommerce: {
      currency: currency,
      value: value,
      items: items
    }
  });
};

var beginCheckout = function beginCheckout(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value,
      coupon = _a.coupon;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.begin_checkout',
    ecommerce: {
      currency: currency,
      value: value,
      coupon: coupon,
      items: items
    }
  });
};

var addShippingInfo = function addShippingInfo(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value,
      coupon = _a.coupon,
      shipping_tier = _a.shipping_tier;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.add_shipping_info',
    ecommerce: {
      currency: currency,
      value: value,
      coupon: coupon,
      shipping_tier: shipping_tier,
      items: items
    }
  });
};

var addPaymentInfo = function addPaymentInfo(_a) {
  var items = _a.items,
      currency = _a.currency,
      value = _a.value,
      coupon = _a.coupon,
      payment_type = _a.payment_type;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.add_payment_info',
    ecommerce: {
      currency: currency,
      value: value,
      coupon: coupon,
      payment_type: payment_type,
      items: items
    }
  });
};

var purchase = function purchase(_a) {
  var items = _a.items,
      transaction_id = _a.transaction_id,
      currency = _a.currency,
      value = _a.value,
      shipping = _a.shipping,
      tax = _a.tax,
      coupon = _a.coupon,
      affiliation = _a.affiliation;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.purchase',
    ecommerce: {
      transaction_id: transaction_id,
      currency: currency,
      value: value,
      shipping: shipping,
      tax: tax,
      affiliation: affiliation,
      coupon: coupon,
      items: items
    }
  });
};

var refund = function refund(_a) {
  var transaction_id = _a.transaction_id,
      items = _a.items,
      currency = _a.currency,
      value = _a.value,
      shipping = _a.shipping,
      tax = _a.tax,
      coupon = _a.coupon,
      affiliation = _a.affiliation;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.refund',
    ecommerce: {
      transaction_id: transaction_id,
      currency: currency,
      value: value,
      shipping: shipping,
      tax: tax,
      affiliation: affiliation,
      coupon: coupon,
      items: items
    }
  });
};

var viewPromotion = function viewPromotion(_a) {
  var items = _a.items,
      promotion_id = _a.promotion_id,
      promotion_name = _a.promotion_name,
      creative_name = _a.creative_name,
      creative_slot = _a.creative_slot,
      location_id = _a.location_id;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.view_promotion',
    ecommerce: {
      promotion_id: promotion_id,
      promotion_name: promotion_name,
      creative_name: creative_name,
      creative_slot: creative_slot,
      location_id: location_id,
      items: items
    }
  });
};

var selectPromotion = function selectPromotion(_a) {
  var items = _a.items,
      promotion_id = _a.promotion_id,
      promotion_name = _a.promotion_name,
      creative_name = _a.creative_name,
      creative_slot = _a.creative_slot,
      location_id = _a.location_id;
  clearEcommerceObject();
  sendTracking({
    event: 'ga4.select_promotion',
    ecommerce: {
      promotion_id: promotion_id,
      promotion_name: promotion_name,
      creative_name: creative_name,
      creative_slot: creative_slot,
      location_id: location_id,
      items: items
    }
  });
};

var EPreviousLinkType;

(function (EPreviousLinkType) {
  EPreviousLinkType["ITEM"] = "matvara";
  EPreviousLinkType["RECIPE"] = "recept";
})(EPreviousLinkType || (EPreviousLinkType = {}));

var EFromLinkPosition;

(function (EFromLinkPosition) {
  EFromLinkPosition["SIDE_MENU"] = "sidopanel";
  EFromLinkPosition["SIDE_MODAL"] = "sidmodal";
  EFromLinkPosition["MY_PAGE"] = "mina-sidor";
  EFromLinkPosition["FOOTER"] = "footer";
})(EFromLinkPosition || (EFromLinkPosition = {}));

var previouslyPurchasLinkEvent = function previouslyPurchasLinkEvent(type, position) {
  sendTracking({
    event: 'previously_purchased_list',
    product_type: type,
    position: position
  });
};

var favoriteLinkEvent = function favoriteLinkEvent(type, position) {
  sendTracking({
    event: 'favorit_product_list',
    product_type: type,
    position: position
  });
};

export { EFromLinkPosition, EPreviousLinkType, addPaymentInfo, addShippingInfo, addToCart, addToWishlist, beginCheckout, clearEcommerceObject, domSafe, favoriteLinkEvent, previouslyPurchasLinkEvent, purchase, refund, removeFromCart, selectItem, selectPromotion, sendTracking, viewCart, viewItemDetails, viewItemList, viewPromotion };